import React from "react";

const MarketingOnline = () => {
  return (
    <>
      <div className="info">
        <p>
          También se necesitan acciones que acompañen a lo que queremos mostrar.
          Actualmente se gasta muchísimo dinero en acciones online que nadie
          sabe a donde van a parar, sólo se ven resultados en tablas que a
          simple vista parecen muy lindas, pero que a la hora de plasmar la
          venta, no siempre tienen los resultados esperados. Nuestro servicio se
          basa en Pagar Por Resultados. Realizamos toda la acción, no sólo la
          del posicionamiento (SEO), sino todas las acciones online para poder
          acercarle un dato (contacto) que realmente esté interesado en su
          producto o servicio. Despreocúpese, nosotros le daremos los contactos
          que usted necesita, para llamarlos y concretar ventas.
        </p>{" "}
        <h4>Redes Sociales</h4>{" "}
        <ul>
          <li>Facebook</li>
          <li>Instagram</li>
          <li>Twitter</li>
          <li>Youtube</li>
          <li>MySpace</li>
          <li>LinkedIn</li>
        </ul>
      </div>{" "}
    </>
  );
};

export default MarketingOnline;
